import { EDD_SOURCE } from '@pperform/pp-constants/parcel';
import type { EddDate } from 'interfaces/edd.interface';
import { isReasonableDeliveryHour } from '../EstimatedDeliveryDate.utils';

/**
 * Resolves the final date/time format strings for a given EDD source.
 * - predict: clears both formats (dateDisplayFormat can embed time tokens)
 * - carrier: clears timeDisplayFormat if either endpoint falls outside 08:00–21:00
 * - others: returns formats unchanged
 */
export const resolveEddFormats = ({
  source,
  startDate,
  endDate,
  timezone,
  dateDisplayFormat,
  timeDisplayFormat,
}: {
  source: string | undefined;
  startDate: EddDate;
  endDate: EddDate | null | undefined;
  timezone: string;
  dateDisplayFormat: string;
  timeDisplayFormat: string;
}): { resolvedDateFormat: string; resolvedTimeFormat: string } => {
  if (source === EDD_SOURCE.predict) {
    return { resolvedDateFormat: '', resolvedTimeFormat: '' };
  }
  if (source === EDD_SOURCE.carrier) {
    // Hide time if outside the delivery hour
    const outsideWindow =
      (startDate.time && !isReasonableDeliveryHour(startDate.time, timezone)) ||
      (endDate?.time && !isReasonableDeliveryHour(endDate.time, timezone));
    return {
      resolvedDateFormat: dateDisplayFormat,
      resolvedTimeFormat: outsideWindow ? '' : timeDisplayFormat,
    };
  }
  return {
    resolvedDateFormat: dateDisplayFormat,
    resolvedTimeFormat: timeDisplayFormat,
  };
};
